import React from "react";

interface Props {
    children: React.ReactNode;
}

const TableBody = ({ children }: Props) => <tbody>{children}</tbody>;

export default TableBody;
